import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Lock } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminLogin() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });
      if (!res.ok) {
        setError('Invalid password');
        setLoading(false);
        return;
      }
      const data = await res.json();
      sessionStorage.setItem('admin_token', data.token);
      navigate('/admin/dashboard');
    } catch {
      setError('Connection error');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="bg-[#1A1A1D] border border-white/10 rounded-2xl p-8">
          <div className="flex justify-center mb-6">
            <div className="w-14 h-14 bg-[#F5A623]/10 rounded-full flex items-center justify-center">
              <Lock className="w-7 h-7 text-[#F5A623]" />
            </div>
          </div>
          <h1 data-testid="admin-login-title" className="text-2xl font-bold text-white text-center mb-6">Admin Access</h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label className="text-gray-300">Password</Label>
              <Input
                data-testid="admin-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter admin password"
                className="bg-[#0A0A0B] border-white/20 text-white h-11"
                required
              />
            </div>
            {error && <p data-testid="admin-login-error" className="text-red-400 text-sm">{error}</p>}
            <Button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-[#F5A623] hover:bg-[#E59400] text-black font-bold h-11"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
